/**
 * CTR Related Articles
 * Arrow navigation for the mobile card slider.
 */

(function () {
  const SECTION_SELECTOR = '[data-ctr-related-articles]';

  function getStep(track) {
    const card = track.querySelector('.ctr-related-articles__card');
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(track, prev, next) {
    const maxScroll = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maxScroll - 1;
  }

  function initSection(section) {
    if (section.dataset.ctrRaReady === 'true') return;

    const track = section.querySelector('[data-ctr-ra-track]');
    const prev = section.querySelector('[data-ctr-ra-prev]');
    const next = section.querySelector('[data-ctr-ra-next]');
    if (!track || !prev || !next) return;

    section.dataset.ctrRaReady = 'true';

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => {
      updateArrows(track, prev, next);
    });

    window.addEventListener('resize', () => {
      updateArrows(track, prev, next);
    });

    updateArrows(track, prev, next);
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
      return;
    }
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function init() {
    initAll(document);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
